var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-sheet',{attrs:{"color":""}},[_c('Toolbar2'),_c('SignUp1')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }